var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3756 7.25239L23.524 9.10394L18.8952 4.46934L20.7468 2.61778C21.1239 2.24061 21.7811 2.24061 22.1583 2.61778L25.3756 5.84086C25.7642 6.22946 25.7642 6.86379 25.3756 7.25239ZM9.90616 22.7392L5.27734 18.1046L17.2437 6.12088L21.8725 10.7555L9.90616 22.7392ZM4.20871 20.339L7.67176 23.8078L2.84864 25.1679L4.20871 20.339ZM27.0271 4.18932L23.8098 0.966237C23.1812 0.337622 20.9125 -0.851032 19.1009 0.966237L2.79721 17.2817C2.65434 17.4245 2.55148 17.596 2.50005 17.7903L0.0427741 26.5394C-0.0715178 26.9452 0.0484887 27.3795 0.339933 27.6824C0.637092 27.9853 1.23141 28.0367 1.48285 27.9795L10.2262 25.5165C10.4205 25.4651 10.5919 25.3622 10.7348 25.2193L27.0271 8.90393C28.3243 7.6067 28.3243 5.49226 27.0271 4.18932Z",
    fill: "url(#paint0_linear_4314_149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_149",
    x1: -4.70556,
    y1: 58.1,
    x2: -31.076,
    y2: 35.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGradient);
export default __webpack_public_path__ + "static/media/pencil_gradient.beb2cca06a06b3ea9bc22e886a4661a5.svg";
export { ForwardRef as ReactComponent };